import { render, staticRenderFns } from "./CompensatoryLeavesEmployeeList.vue?vue&type=template&id=715fcfdd"
import script from "./CompensatoryLeavesEmployeeList.vue?vue&type=script&lang=js"
export * from "./CompensatoryLeavesEmployeeList.vue?vue&type=script&lang=js"
import style0 from "./CompensatoryLeavesEmployeeList.vue?vue&type=style&index=0&id=715fcfdd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports